(function ($) {
  'use strict';

  /* ========================================================================= */
  /*	Page Preloader
  /* ========================================================================= */
  $(window).on('load', function () {
    $('#preloader').fadeOut('slow', function () {
      $(this).remove();
    });
  });


  // navbarDropdown
	if ($(window).width() < 992) {
		$('#navigation .dropdown-toggle').on('click', function () {
			$(this).siblings('.dropdown-menu').animate({
				height: 'toggle'
			}, 300);
		});
  }
  
  //Hero Slider
  $('.hero-slider').slick({
    autoplay: true,
    infinite: true,
    arrows: true,
    prevArrow: '<button type=\'button\' class=\'prevArrow\'></button>',
    nextArrow: '<button type=\'button\' class=\'nextArrow\'></button>',
    dots: false,
    autoplaySpeed: 7000,
    pauseOnFocus: false,
    pauseOnHover: false
  });
  $('.hero-slider').slickAnimation();

  /* ========================================================================= */
  /*	Testimonial Carousel
  /* =========================================================================  */
  //Init the slider
  $('.testimonial-slider').slick({
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000
  });


  /* ========================================================================= */
  /*	Clients Slider Carousel
  /* =========================================================================  */
  //Init the slider
  $('.clients-logo-slider').slick({
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false
      }
    }
    ]
  });

  /* ========================================================================= */
  /*	Company Slider Carousel
  /* =========================================================================  */
  $('.company-gallery').slick({
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 667,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false
      }
    }
    ]
  });

  /* ========================================================================= */
  /*	On scroll fade/bounce effect
  /* ========================================================================= */
  // The URL hash is user-controlled: decode it defensively (a stray "%"
  // makes decodeURIComponent throw) and only ever use it as an element id.
  function getHashId() {
    try {
      return decodeURIComponent(window.location.hash.slice(1));
    } catch (e) {
      return '';
    }
  }

  var scroll = new SmoothScroll('a[href*="#"]:not(.finder-card):not(.policy-link)');

  // -----------------------------
  //  Count Up
  // -----------------------------
  function counter() {
    var oTop;
    if ($('.counter').length !== 0) {
      oTop = $('.counter').offset().top - window.innerHeight;
    }
    if ($(window).scrollTop() > oTop) {
      $('.counter').each(function () {
        var $this = $(this),
          countTo = $this.attr('data-count');
        $({
          countNum: $this.text()
        }).animate({
          countNum: countTo
        }, {
          duration: 1000,
          easing: 'swing',
          step: function () {
            $this.text(Math.floor(this.countNum));
          },
          complete: function () {
            $this.text(this.countNum);
          }
        });
      });
    }
  }
  // -----------------------------
  //  On Scroll
  // -----------------------------
  $(window).scroll(function () {
    counter();

    var scroll = $(window).scrollTop();
    if (scroll > 50) {
      $('.navigation').addClass('sticky-header');
    } else {
      $('.navigation').removeClass('sticky-header');
    }
  });

  // -----------------------------
  //  Service Panels (Our Services page expandable detail panels)
  // -----------------------------
  if ($('.service-panels').length) {
    var servicePanelTimer;
    var activateServicePanel = function ($panel) {
      if ($panel.hasClass('active')) {
        return;
      }
      var $panels = $panel.closest('.service-panels').find('.service-panel');

      clearTimeout(servicePanelTimer);

      // Fade out / re-orient the other panels' content immediately, but
      // delay switching the clicked panel's content to its expanded layout
      // until its width transition is mostly done - avoids the horizontal
      // text/content popping into a box that is still animating narrower/wider.
      $panels.removeClass('active layout-active').find('.service-panel-head').attr('aria-expanded', 'false');
      $panel.addClass('active');
      $panel.find('.service-panel-head').attr('aria-expanded', 'true');

      servicePanelTimer = setTimeout(function () {
        $panel.addClass('layout-active');
      }, 200);
    };

    $('.service-panels').on('click', '.service-panel-head', function () {
      activateServicePanel($(this).closest('.service-panel'));
    });

    var scrollToServicePanels = function () {
      var navOffset = $('.navigation').outerHeight() || 0;
      $('html, body').animate({
        scrollTop: $('#service-panels').offset().top - navOffset - 20
      }, 500);
    };

    // "Start with what you need most" finder cards: open the matching
    // panel below and scroll to it, keeping the fixed navbar clear.
    $('.finder-card').on('click', function (e) {
      var targetId = $(this).attr('href');
      var $panel = $(targetId);
      if (!$panel.length || !$panel.hasClass('service-panel')) {
        return;
      }
      e.preventDefault();

      activateServicePanel($panel);
      scrollToServicePanels();
    });

    // Arriving from elsewhere (e.g. the homepage "Learn More" links) with a
    // hash matching a panel id: open that panel and correct the scroll
    // position, since the browser's own hash-jump lands on the panel itself
    // without accounting for the fixed navbar.
    if (window.location.hash) {
      // Look the hash up by id rather than passing it to $() as a selector:
      // it is user-controlled, and a malformed value would throw and halt
      // the rest of this script.
      var $hashPanel = $(document.getElementById(getHashId()));
      if ($hashPanel.length && $hashPanel.hasClass('service-panel')) {
        activateServicePanel($hashPanel);
        scrollToServicePanels();
      }
    }
  }

  // -----------------------------
  //  Policy Tabs (Resources page - Our Policies)
  // -----------------------------
  if ($('.policy-tabs').length) {
    var activatePolicyTab = function (target) {
      var $tab = $('.policy-tabs').find('[data-target="' + target + '"]');
      var $doc = $('#' + target);
      if (!$tab.length || !$doc.length) {
        return;
      }
      var $wrap = $tab.closest('.policies-section');

      $wrap.find('.policy-tab').removeClass('active').attr('aria-expanded', 'false');
      $tab.addClass('active').attr('aria-expanded', 'true');

      $wrap.find('.policy-doc').removeClass('active');
      $doc.addClass('active').scrollTop(0);
    };

    $('.policy-tabs').on('click', '.policy-tab', function () {
      var $tab = $(this);
      if ($tab.hasClass('active')) {
        return;
      }
      activatePolicyTab($tab.data('target'));
    });

    // Links to a policy tab from elsewhere on this page (FAQ answers, other
    // policy tabs): switch tab and scroll to the Policies section.
    $(document).on('click', 'a.policy-link', function (e) {
      var id = (this.getAttribute('href') || '').split('#')[1];
      if (!id || !$(document.getElementById(id)).hasClass('policy-doc')) {
        return;
      }
      e.preventDefault();
      activatePolicyTab(id);
      var navOffset = $('.navigation').outerHeight() || 0;
      $('html, body').stop(true).animate({
        scrollTop: $('#policies').offset().top - navOffset - 20
      }, 500);
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + id);
      }
    });

    // Arriving from elsewhere (e.g. footer policy links) with a hash
    // matching a policy document id: select that tab and scroll to it,
    // keeping the fixed navbar clear.
    if (window.location.hash) {
      var hashTarget = getHashId();
      if ($(document.getElementById(hashTarget)).hasClass('policy-doc')) {
        activatePolicyTab(hashTarget);

        // Measure once the page has finished laying out: the FAQ list
        // above collapses to its first batch of questions during init, and
        // measuring earlier overshoots the Policies section by that height.
        var scrollToPolicies = function () {
          var navOffset = $('.navigation').outerHeight() || 0;
          $('html, body').stop(true).animate({
            scrollTop: $('#policies').offset().top - navOffset - 20
          }, 500);
        };
        // The browser also performs its own jump to the (now visible) policy
        // document when the load event fires; wait it out so ours wins.
        var scrollAfterNativeJump = function () {
          setTimeout(scrollToPolicies, 100);
        };
        if (document.readyState === 'complete') {
          scrollAfterNativeJump();
        } else {
          $(window).one('load', scrollAfterNativeJump);
        }
      }
    }
  }

  // -----------------------------
  //  Error pages (5xx): retry button + timestamp reference
  // -----------------------------
  $(document).on('click', '.js-reload', function (e) {
    e.preventDefault();
    window.location.reload();
  });

  var $errorRef = $('.js-error-ref');
  if ($errorRef.length) {
    $errorRef.text(new Date().toLocaleString('en-AU', {
      dateStyle: 'medium',
      timeStyle: 'short'
    }));
    $errorRef.closest('.nf-ref').prop('hidden', false);
  }

  // -----------------------------
  //  FAQ accordion (Resources page) - one answer open at a time
  // -----------------------------
  if ($('.faq-list').length) {
    var openFaq = function ($item, open) {
      $item.toggleClass('open', open);
      $item.find('.faq-question').attr('aria-expanded', open ? 'true' : 'false');
      var $ans = $item.find('.faq-answer');
      if (open) {
        $ans.prop('hidden', false).hide().slideDown(200);
      } else {
        $ans.slideUp(200, function () { $ans.prop('hidden', true); });
      }
    };

    // Show the questions 5 at a time; the "More" button sits below the
    // list, so it moves down as each batch is revealed.
    var FAQ_BATCH = 5;
    var $faqMore = $('.faq-more');
    var $faqHidden = $('.faq-item').slice(FAQ_BATCH).addClass('faq-item-hidden');
    $faqMore.prop('hidden', !$faqHidden.length);

    $faqMore.on('click', function () {
      $('.faq-item-hidden').slice(0, FAQ_BATCH).each(function () {
        $(this).removeClass('faq-item-hidden').hide().slideDown(250);
      });
      if (!$('.faq-item-hidden').length) {
        $faqMore.prop('hidden', true);
      }
    });

    $('.faq-list').on('click', '.faq-question', function () {
      var $item = $(this).closest('.faq-item');
      var willOpen = !$item.hasClass('open');
      $item.siblings('.open').each(function () { openFaq($(this), false); });
      openFaq($item, willOpen);
    });
  }

  // -----------------------------
  //  Team Member Bio (About page - "More" expand)
  // -----------------------------
  if ($('.member-more').length) {
    $('.team').on('click', '.member-more', function () {
      var $btn = $(this);
      var $bio = $btn.siblings('.member-bio');
      var expanded = $bio.hasClass('expanded');

      if (expanded) {
        $bio.addClass('truncated').removeClass('expanded');
        $btn.text('More');
      } else {
        $bio.addClass('expanded').removeClass('truncated');
        $btn.text('Less');
      }
    });
  }

})(jQuery);
